<template>
    <div class="translates p-3">
        <b-tabs >
            <b-tab v-for="tab in tabs" :key="'lang_tab-' + tab.uniq_id" :title="get_tab_title(tab)">
                <div class="language_block mb-4 mt-4">

                    <div class="form-group mt-2">
                        <label class="form-label" for="locale">
                            {{__t("LOCALE")}}
                            <button type="button" class="btn btn-xs btn-dark waves-effect waves-themed"
                                    v-if="parseInt(tab.locale_id) > 0"
                                    v-on:click="make_ai_translate(tab.locale_id,tab)">AI translate</button>
                        </label>

                        <div class="" v-if="locales.length > 0">
                            <v-select v-model="tab.locale_id"
                                      class="imc_reasons"
                                      label="name"
                                      :reduce="locale => locale.id"
                                      :options="select_locales"
                                      :filterable="false"
                                      :selectable="(option) => option.can_select"
                            >
                                <template slot="no-options">
                                    {{__t("SELECT_LOCALE")}}
                                </template>

                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <div>
                                            {{ option.name }}
                                            <div>
                                                <span class="small badge border border-info  text-info mr-1"> {{option.site_code}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>

                    <div class="fields">
                        <b-overlay :show="is_ai_work">
                            <div class="form-group mt-2" v-for="field in tab.fields">
                                <label class="form-label" :for="'advanced' + field.type">
                                    {{__t("FIELD_" + field.type)}}
                                </label>
                                <div class="input-group flex-nowrap">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="fal  fa-typewriter fs-xl" ></i>
                                        </span>
                                    </div>

                                    <input v-if="field.type != 'description'" id="ctg_ordering" type="text" class="form-control" v-model="field.val">
                                    <textarea v-else id="description" type="text" class="form-control" v-model="field.val"></textarea>
                                </div>
                            </div>
                        </b-overlay>
                    </div>
                </div>

                <b-button size="sm" variant="danger" class="float-right" @click="closeTab(tab.uniq_id)">
                    {{__t('REMOVE')}}
                </b-button>
            </b-tab>

            <template #tabs-end>
                <b-nav-item role="presentation" @click.prevent="newTab" href="#">
                    <b>+</b>
                </b-nav-item>
            </template>

            <template #empty>
                <div class="text-center text-muted">
                    {{__t('EMPTY_LANGUAGES')}}
                </div>
            </template>
        </b-tabs>
    </div>
</template>

<script>

import vSelect from 'vue-select'

export default {
    name: "translates",
    components : {
        vSelect
    },

    props : {
        item_id : {
            type: Number,
            required :true
        } ,
        item_type : {
            type :String,
            required: true
        },
    },

    data() {
        return {
            locales : [],
            item_data : [],
            tabs: [],
            tabCounter: 0,
            item_types : [],
            is_ai_work : false,
        }
    },

    created () {
      this.load_params();
        EventBus.$on("save_translation", this.save_translates);
    },
    destroyed() {
        EventBus.$off("save_translation", this.save_translates);
    },

    methods: {

        async make_ai_translate(locale_id,tab) {
            if(this.is_ai_work) {
                return;
            }

            this.is_ai_work = true;
            await api.get('/internal/v1/ai/translate/'+ locale_id +'/products/'+ this.item_id,).then(({data}) => {
                this.is_ai_work = false;
                if (data.status === "operation_success") {
                    let resp = data.data;
                    let title = resp.title.comment;
                    let description = resp.description.comment;

                    tab.fields.map(field => {
                        if (field.type === 'title') {
                            field.val = title;
                        } else if (field.type === 'description') {
                            field.val = description;
                        }
                    });
                }
            })
                .catch(({response}) => {
                    this.is_ai_work = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
        },

        get_tab_title (tab) {
            let name = this.__t("NEW_LANG");
            if(tab.hasOwnProperty("locale_id")) {
                if (tab.locale_id == null || tab.locale_id == 0) {

                } else {

                    this.locales.map(item => {
                        if (parseInt(item.id) == parseInt(tab.locale_id)) {
                            name = item.name;
                        }
                    })
                }
            }
            return name;
        },

        save_translates(item_id,item_type,done) {
            console.log('sa',item_id,item_type,done);

            if(parseInt(item_id) == parseInt(this.item_id) && this.item_type == item_type) {
                this.store_translate().then(({data}) => {
                    done();
                }).catch(({response}) => {
                    done();
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            }
            else {
                done();
            }
        },
        async store_translate()
        {
            return api.put('/internal/v1/catalog/translates/' + this.item_type + "/" + this.item_id , this.lang_data);
        },

        async load_params() {
            this.locales = [];
            await api.get('/api/v2/locales',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.locales = data.data;
                }
                return data;
            }).then(({data}) => {
                return this.load_item_translates();
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async load_item_translates() {
            await api.get('/internal/v1/catalog/translates/' + this.item_type + "/" + this.item_id,{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.item_data = data.data;
                    if(this.item_data != null && this.item_data.length > 0) {
                        this.tabs = [];
                        this.item_data.map(item => {
                            item.uniq_id = item.locale_id;
                            this.tabs.push(item);
                        })
                    }

                    this.item_types = data.message;
                }

            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        closeTab(x) {
            for (let i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i].uniq_id === x) {
                    this.tabs.splice(i, 1)
                }
            }
        },
        newTab() {
            this.tabs.push(this.get_default_tab());
        },

        get_default_tab () {
            let tab  = {
                'uniq_id' : this.tabs.length + 1,
                'locale_id' : 0,
                'fields' : [],
            }

            if(this.item_types.length > 0) {
                this.item_types.map(type => {
                    tab.fields.push({
                        "type" : type,
                        'val' : "",
                    })
                });
            }

            return tab;
        },
    },
    computed : {

        lang_data() {
            let res = [];
            this.tabs.map(item => {
                res.push({
                    'fields' : item.fields,
                    'locale_id' : item.locale_id
                });
            });
            return res;
        },


        select_locales() {
            return this.locales.map(item => {
                item.can_select = true;
                this.tabs.map(tab => {
                    if (parseInt(item.id) == parseInt(tab.locale_id)) {
                        item.can_select = false;
                    }
                })
                return item;
            });
        },
    }
}
</script>

<style scoped>

</style>
